module.exports = __webpack_public_path__ + "static/img/bg-sai-score.87a1613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-sai-score.png
// module id = 817
// module chunks = 0